// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2106":"51719675","3009":"51719675","3120":"07983528","4843":"51719675"}[chunkId] + ".chunk.css";
};